import React from 'react';
import PropTypes from 'prop-types';

const CustomPageFooter = (props) => {

  let {
    footerBlock
  } = props;

  return (
    <React.Fragment>
      <footer id="doterai-footer">
        <div className="container-fluid">
          <div className="doterai-footer text-center">
            <div className="brand-logo"><img className="img-fluid" src="https://static.test.aperza.com/common/images/brands/doterai-logo.png" /></div>
            <div className="brand-adm">
              <p className="font-weight-bold">運営：どてらい市事務局</p>
            </div>
            <ul className="footer-nav d-flex flex-row justify-content-center">
              <li className="footer-nav-item"><a href="https://cloud.aperza.com/help/wp-content/doterai/privacy_policy_v1.pdf" target="_blank">個人情報保護方針</a></li>
              <li className="footer-nav-item"><a href="https://cloud.aperza.com/help/wp-content/doterai/term_v1.pdf" target="_blank">利用規約</a></li>
              <li className="footer-nav-item"><a href="https://form.run/@inquiry-doterai-com" target="_blank">お問い合わせ</a></li>
            </ul>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};

CustomPageFooter.propTypes = {
  footerBlock: PropTypes.shape({
    footerType: PropTypes.string,
    footerContents: PropTypes.string,
  }).isRequired,
};

export default CustomPageFooter;
